import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { ThemeProvider } from "@emotion/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "material-icons/iconfont/material-icons.css";
import { useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { ModalProvider } from "./contexts";
import router from "./routes/router";
import { GlobalStyles } from "./styles/global";
import theme from "./styles/theme";

const App = () => {
    const [queryClient] = useState(() => new QueryClient());
    const customTheme = extendTheme(theme);

    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .getRegistrations()
            .then(function (registrations) {
                registrations.forEach((registration) => {
                    registration.unregister();
                });
            })
            .catch(function (err) {
                console.error("Service Worker 제거 중 오류:", err);
            });
    }

    return (
        <QueryClientProvider client={queryClient}>
            <RecoilRoot>
                <ChakraProvider theme={customTheme}>
                    <ModalProvider>
                        <ThemeProvider theme={theme}>
                            <GlobalStyles />
                            <HelmetProvider>
                                <RouterProvider router={router()} />
                            </HelmetProvider>
                        </ThemeProvider>
                    </ModalProvider>
                </ChakraProvider>
            </RecoilRoot>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

export default App;
